<template>
<div class="ui segments">

  <div class="ui segment">
    <div class="ui breadcrumb">
      <router-link :to="{name:'home'}" class="section">Sākums</router-link>
      <span class="divider">/</span>
      <div class="active section">Profila informācija/paroles maiņa</div>
    </div>
  </div>

  <div class="ui segment" v-bind:class="{ loading: storeStatus.loading }">
    <table class="ui very basic table">

      <tbody>
        <tr>
          <td><span v-if="user.person_type == 1">Vārds Uzvārds</span>
            <span v-else>Nosaukums</span>:</td>
          <td>{{user.name_surname}}</td>
        </tr>
        <tr>
          <td><span v-if="user.person_type == 1">Personas kods</span>
            <span v-else>Reģistrācijas nr.</span>:</td>
          <td>{{user.legalid}}</td>
        </tr>
        <tr>
          <td>E-pasts:</td>
          <td>{{user.email}}</td>
        </tr>
        <tr>
          <td>Tālrunis:</td>
          <td>{{user.phone}}</td>
        </tr>
        <tr v-if="user.lyones_id != ''">
          <td>Lyoness id:</td>
          <td>{{user.lyones_id}}</td>
        </tr>
        <tr v-if="user.bail_payed > 0 || user.bail_required > 0">
          <td>Iemaksātā drošības nauda:</td>
          <td>{{user.bail_payed}} &euro;</td>
        </tr>
        <tr v-if="user.bail_payed > 0 || user.bail_required > 0">
          <td>Vajadzīgā drošības nauda:</td>
          <td>{{user.bail_required}} &euro;</td>
        </tr>
        <tr v-if="user.pay_later > 0 && user.credit_limit > 0">
          <td>Kredītlimits:</td>
          <td>{{user.credit_limit}} &euro;</td>
        </tr>
        <tr>
          <td>&nbsp;</td>
          <td>
            <div class="ui checkbox">
              <input id="newsletter" type="checkbox" :checked="user.newsletter" v-on:change="updateNewsletter" number>
              <label for="newsletter">Vēlos saņemt jaunumus</label>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="ui segment">
    <div v-if="passwordChanged" class="ui success message">
      <p>Parole veiksmīgi nomainīta!</p>
    </div>
    <div v-if="storeStatus.error != ''" class="ui negative message">
      Parolei jāsatur vismas 8 simbolus!
    </div>
    <div class="ui form">
      <h4 class="ui dividing header">Paroles maiņa</h4>
      <div class="two fields">
        <div class="field">
          <label>Jaunā parole</label>
          <input type="password" v-model="credentials.password" placeholder="Minimums 8 simboli">
        </div>
        <div class="field">
          <label>Jaunā parole atkārtoti</label>
          <input type="password" v-model="credentials.paswordRepeat" placeholder="Minimums 8 simboli">
        </div>
      </div>
    </div>
    <button v-on:click="updatePassword" :disabled="credentials.password == '' || credentials.password.legend < 8 || credentials.password != credentials.paswordRepeat" class="ui right floated custom_brown button" v-bind:class="{ loading: showLoader}">
    Mainīt paroli</button>
    <div class="ui clearing hidden divider"></div>
  </div>

</div>
</template>

<script>
export default {

  data() {
    return {
      credentials: {
        password: '',
        paswordRepeat: ''
      },
      passwordChanged: false,
      showLoader: false
    }
  },
  computed: {
    user() {
      return this.$store.state.userStore.user
    },
    storeStatus() {
      return this.$store.state.userStore.status
    }
  },

  activated: function() {
    //reset default values
    this.passwordChanged = false;
    //preload data
    this.$store.dispatch('loadUser');
  },
  methods: {
    updateNewsletter: function() {
      var user = JSON.parse(JSON.stringify(this.user)); //copy object
      user.newsletter = (user.newsletter) ? 0 : 1;
      this.$store.dispatch('updateUser', user);
    },

    updatePassword: function() {

      this.passwordChanged = false; //reset value
      this.showLoader = true;
      this.$store.dispatch('updateUserPassword', [this.user, this.credentials]).then((response) => {
        this.credentials.password = ""; //reset credentials so that they dont hang in local component state
        this.credentials.paswordRepeat = "";
        this.passwordChanged = true;
        this.showLoader = false;
      }).catch((error) => {
        this.passwordChanged = false;
        this.showLoader = false;
      });
    }
  }
}
</script>



// WEBPACK FOOTER //
// UserProfilePage.vue?4b167507